import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import clientService from "../services/client.service";
import { Clientvalidationschema } from "../components/Validation";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import imagename from "../assets/images/user.png";
import authsService from "../services/auths.service";

const Clientevent = (props) => {
  const userinfo = authsService.userinfo();
  const [showPass, setShowPass] = useState(false);
  const ref = useRef();
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const [client_id, setClientid] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventname, setEventname] = useState("view");

  //form initial value
  const formik = useFormik({
    initialValues: {
      client_id: "",
      client_fullname: "",
      client_username: "",
      client_password: "",
      client_email: "",
      client_phone: "",
      client_address: "",
      client_role: "",
      client_start_at: "",
      client_end_at: "",
      client_status: "",
      user_name: userinfo.user_name,
    },
    validationSchema: Clientvalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      //alert(JSON.stringify(values, null, 1));
      /*  resetForm({ values: '' }) */
    },
  });
  //use effects
  useEffect(() => {
    setClientid(searchParams.get("client_id"));
    if (searchParams.get("client_id")) {
      setEventname("view");
      getClient(searchParams.get("client_id"));
    } else {
      setEventname("create");
    }
  }, []);

  //current event
  const clientEvent = (eventname, value) => {
    if (value) {
      getClient(value);
    }
    setEventname(eventname);
  };

  //get client
  const getClient = (value) => {
    setIsLoaded(true);
    clientService
      .getClient(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            client_id: data.client_id,
            client_username: data.client_username,
            client_fullname: data.client_fullname,
            client_password: data.client_password,
            client_email: data.client_email,
            client_phone: data.client_phone,
            client_address: data.client_address,
            client_role: data.client_role,
            client_start_at: data.client_start_at,
            client_end_at: data.client_end_at,
            client_status: data.client_status == null ? "" : data.client_status,
            user_name: userinfo.user_name,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  //create client
  const createClient = () => {
    clientService
      .createClient(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          console.log(res.data);
          setIsLoaded(false);
          navigate("/client");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };

  //update client
  const updateClient = () => {
    console.log(JSON.stringify(formik.values, null, 2));
    clientService
      .updateClient(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          clientEvent("view");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //delete client
  const deleteClient = (value) => {
    console.log(value);
    clientService
      .deleteClient(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          navigate("/client");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  // Call client clicks to request another page.
  if (isLoaded) {
    <Loader />;
  } else {
    return (
      <div className="container">
        {/*  container */}
        <div className="client-container">
          {/* form container */}
          <div className="card shadow-sm border-0 ">
            <div className="card-body ">
              <div className="d-flex p-2 ">
                <h5 className="card-title p-0 m-0 me-auto"></h5>
                {eventname == "create" ? (
                  <></>
                ) : (
                  <div>
                    <div className="dropdown">
                      <a
                        className="btn  btn-link"
                        href="#"
                        role="button"
                        id="clienteventdropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="clienteventdropdownMenuLink"
                      >
                        <li>
                          <a
                            onClick={() => {
                              navigate(
                                "/clientsetup?selected=category&client_id=" +
                                  searchParams.get("client_id")
                              );
                            }}
                            className="dropdown-item"
                          >
                            Setup
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              clientEvent("edit");
                            }}
                            className="dropdown-item"
                          >
                            Edit
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => clientEvent("delete")}
                            className="dropdown-item"
                          >
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/*  profile section */}
                  <div className="col-md-3 ">
                    <div
                      className="d-flex justify-content-center "
                      style={{ position: "relative" }}
                    >
                      <div>
                        <img
                          style={{
                            width: 150,
                            height: 150,
                            borderRadius: "50%",
                          }}
                          src={imagename ? imagename : imagename}
                        />
                      </div>
                      {/* <div
                        style={{ position: "absolute", bottom: 0, right: 90 }}
                      >
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#uploadmodal"
                          className="btn btn-sm btn-secondary "
                        >
                          <i className="fa fa-pencil-square-o"></i>
                        </button>
                      </div> */}
                    </div>
                    <div>
                      <div className="col-md-12">
                        <label htmlFor="client_username" className="form-label">
                          Clientname
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter username"
                            id="client_username"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_username")}
                          />
                        </div>
                        <div>
                          {formik.touched.client_username &&
                          formik.errors.client_username ? (
                            <div className="error">
                              {formik.errors.client_username}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label
                          className="form-label me-4"
                          htmlFor="client_password"
                        >
                          Password
                        </label>
                        <div className="input-group ">
                          <input
                            className="form-control"
                            id="client_password"
                            type={showPass ? "text" : "password"}
                            autoComplete="off"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_password")}
                          />
                          <span
                            onClick={() => setShowPass(!showPass)}
                            className="input-group-text bg-white"
                          >
                            <i
                              className={
                                showPass ? "fa fa-eye-slash" : "fa fa-eye"
                              }
                            ></i>{" "}
                          </span>
                        </div>
                        {formik.touched.client_password &&
                        formik.errors.client_password ? (
                          <div className="error">
                            {formik.errors.client_password}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-12">
                        <label htmlFor="client_email" className="form-label">
                          Email
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter Email"
                            id="client_email"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_email")}
                          />
                        </div>
                        <div>
                          {formik.touched.client_email &&
                          formik.errors.client_email ? (
                            <div className="error">
                              {formik.errors.client_email}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* form section */}
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-md-12 ">
                        <label htmlFor="client_fullname" className="form-label">
                          Fullname
                        </label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            placeholder="Enter Fullname"
                            id="client_fullname"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_fullname")}
                          />
                        </div>
                        <div>
                          {formik.touched.client_fullname &&
                          formik.errors.client_fullname ? (
                            <div className="error">
                              {formik.errors.client_fullname}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label htmlFor="client_phone" className="form-label">
                          Phone
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter Phone"
                            id="client_phone"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_phone")}
                          />
                        </div>
                        <div>
                          {formik.touched.client_phone &&
                          formik.errors.client_phone ? (
                            <div className="error">
                              {formik.errors.client_phone}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-12 ">
                        <label htmlFor="client_address" className="form-label">
                          Address
                        </label>
                        <div className="input-group">
                          <textarea
                            className="form-control"
                            placeholder="Enter Address"
                            id="client_address"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_address")}
                          ></textarea>
                        </div>
                        <div>
                          {formik.touched.client_address &&
                          formik.errors.client_address ? (
                            <div className="error">
                              {formik.errors.client_address}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_start_at" className="form-label">
                          Start date
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter start date"
                            id="client_start_at"
                            type="date"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_start_at")}
                          />
                        </div>
                        <div>
                          {formik.touched.client_start_at &&
                          formik.errors.client_start_at ? (
                            <div className="error">
                              {formik.errors.client_start_at}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_end_at" className="form-label">
                          End date
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter end date"
                            id="client_end_at"
                            type="date"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("client_end_at")}
                          />
                        </div>
                        <div>
                          {formik.touched.client_end_at &&
                          formik.errors.client_end_at ? (
                            <div className="error">
                              {formik.errors.client_end_at}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_role" className="form-label">
                          Role
                        </label>
                        <div className="input-group col-md-6">
                          <select
                            id="client_role"
                            {...formik.getFieldProps("client_role")}
                            className="form-select"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            aria-label="client_role"
                          >
                            <option value="" disabled>
                              Select Role
                            </option>
                            <option value="admin">Admin</option>
                            <option value="member">Principal</option>
                          </select>
                        </div>
                        <div>
                          {formik.touched.client_role &&
                          formik.errors.client_role ? (
                            <div className="error">
                              {formik.errors.client_role}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_status" className="form-label">
                          status
                        </label>
                        <div className="input-group col-md-6">
                          <select
                            id="client_status"
                            {...formik.getFieldProps("client_status")}
                            className="form-select"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            aria-label="client_status"
                          >
                            <option value="" disabled>
                              Select status
                            </option>
                            <option value="pending">Pending</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </div>
                        <div>
                          {formik.touched.client_status &&
                          formik.errors.client_status ? (
                            <div className="error">
                              {formik.errors.client_status}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-12 pt-2 pb-2">
                        {eventname === "create" ? (
                          <>
                            <button
                              disabled={!formik.isValid || !formik.dirty}
                              onClick={() => createClient()}
                              className="btn btn-primary me-2"
                            >
                              Create
                            </button>
                            <button
                              onClick={formik.handleReset}
                              className="btn btn-secondary"
                            >
                              Clear
                            </button>
                          </>
                        ) : eventname === "edit" ? (
                          <>
                            {" "}
                            <button
                              disabled={!formik.isValid || !formik.dirty}
                              onClick={() => updateClient()}
                              className="btn btn-primary me-2"
                            >
                              Update
                            </button>
                            <button
                              onClick={() => clientEvent("view")}
                              className="btn btn-secondary"
                            >
                              Cancel
                            </button>
                          </>
                        ) : eventname === "delete" ? (
                          <>
                            <button
                              onClick={() =>
                                deleteClient(formik.values.client_id)
                              }
                              className="btn btn-danger me-2 "
                            >
                              Delete
                            </button>
                            <button
                              onClick={() => clientEvent("view")}
                              className="btn btn-secondary"
                            >
                              Cancel
                            </button>
                          </>
                        ) : (
                          <>
                            {/* <button onClick={() => navigate('/clientloyee')} className='btn btn-primary' >Back</button> */}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/*  loader and error handler */}
          {/*  {iserror === false || iserror === true ? <Alertmsg alertmsg={ismessage} type={iserror} /> : <></>} */}
          <Toastmessage ref={ref} />
          {/* <Alertmsg ref={ref}/> */}
        </div>
      </div>
    );
  }
};

export default Clientevent;
